export const NOTES_GET              = 'notes/NOTES_GET';
export const NOTES_GET_SUCCESS      = 'notes/NOTES_GET_SUCCESS';
export const NOTES_GET_ERROR        = 'notes/NOTES_GET_ERROR';
export const NOTES_SET              = 'notes/NOTES_SET';
export const NOTES_SET_SUCCESS      = 'notes/NOTES_SET_SUCCESS';
export const NOTES_SET_ERROR        = 'notes/NOTES_SET_ERROR';